import React, { useState, useEffect, useRef, useContext  } from 'react';
import { Alert } from 'antd';
import {BrandContext} from "@context/BrandContext";
import CircularLoader from "@common/CircularLoader";

const ScorcherPlayer = props => {
    const {stepId, scorcherType = 'CONCEPT', multipleAttempts = false, timerMode = true, onContinue} = props;
    const brandConfig = useContext(BrandContext);
    const canvasRef = useRef(null);
    const [scorcherPlayer, setScorcherPlayer] = useState(window.globalReactFunctions?.scorcherPlayer);
    const CANVAS_WIDTH = 940;
    const CANVAS_HEIGHT = 650;
    const CANVAS_RATIO = CANVAS_WIDTH / CANVAS_HEIGHT;

    useEffect(() => {
        const scorcherContinue = () => {
            if (onContinue && typeof onContinue === 'function') onContinue();
        }
        window.addEventListener('ch-ev-scorcherContinue', scorcherContinue);
        return () => {
            window.removeEventListener('ch-ev-scorcherContinue', scorcherContinue);
        }
    }, []);

    const resizeScorcherCanvas = () => {
        const canvas = canvasRef.current;
        if (canvas && scorcherType === 'CONCEPT') {
            const dialogCont = canvas.closest('.ch-dialog-content');

            const contentWidth = dialogCont.clientWidth;
            const contentHeight = (window.innerHeight - (dialogCont.className.includes('fullscreen') ? 108 : 170));

            const tempCanvasRatio = contentWidth / contentHeight;

            let canvasWidth, canvasHeight;

            if (tempCanvasRatio >= CANVAS_RATIO) {
                canvasWidth = contentHeight * CANVAS_RATIO;
                canvasHeight = contentHeight;
            } else {
                canvasWidth = contentWidth;
                canvasHeight = contentWidth / CANVAS_RATIO;
            }

            canvas.style.width = `${canvasWidth}px`;
            canvas.style.height = `${canvasHeight}px`;
        } else if (canvas) {
            canvas.style.height = `${window.innerHeight - 300}px`;
        }
    };

    if (window.globalReactFunctions) {
        window.globalReactFunctions.resizeScorcherCanvas = resizeScorcherCanvas;
    }

    const loadScorcherPlayer = () => {
        if (scorcherPlayer) {
            scorcherPlayer.destroy();
        }

        let params = `time=${Date.now()}${scorcherType === `PATHWAY` ? `&stepId=${stepId}` : ``}`;
        const url = `/scorcher/get${scorcherType === `PATHWAY` ? `Inline` : ``}ScorcherJson.action?${params}`;
        const locScorcherPlayer = new gamelearn.Scorcher(canvasRef.current, url, brandConfig.brandCode, 10, scorcherType, multipleAttempts, timerMode);
        window.scorcherPlayer = locScorcherPlayer;
        setScorcherPlayer(locScorcherPlayer);

        resizeScorcherCanvas();
    };

    useEffect(() => {
        if (!canvasRef?.current) return;
        loadScorcherPlayer();
        
        window.addEventListener('resize', resizeScorcherCanvas);
        return () => {
            window.removeEventListener('resize', resizeScorcherCanvas);
            if (scorcherPlayer) scorcherPlayer.destroy();
        };
    }, [stepId, scorcherType, multipleAttempts, timerMode, canvasRef?.current]);

    if ((scorcherType === 'PATHWAY' && stepId == undefined)) {
        return (
            <Alert
                message={'No Scorcher available'}
                type="error"
                showIcon
            />
        );
    }

    return (
        <div className={`ch-scorcher-player-wrapper`}>
            <CircularLoader visible={!scorcherPlayer} />
            <canvas
                ref={canvasRef}
                width={CANVAS_WIDTH}
                height={CANVAS_HEIGHT}
            />
        </div>
    );
};

export default ScorcherPlayer;
